import { setSessionStorage, getSessionStorage } from '../../untils/storage'

const state = {
  isLogin: getSessionStorage('isLogin') || false,
  userId: getSessionStorage('userId') || '',
  chksts: getSessionStorage('chksts') || '',
  userName: getSessionStorage('userName') || '',
  isEmail: '',
  email: '',
  newEmail: '',
  schedule: getSessionStorage('schedule') || '',
  updcardsch: getSessionStorage('updcardsch') || '',
  updcussch: getSessionStorage('updcussch') || '',
  goPage: getSessionStorage('goPage') || ''
}

const mutations = {
  SAVE_GOPAGE (state, goPage) {
    state.goPage = goPage;
    setSessionStorage('goPage', goPage);
  },
  SAVE_UPDCUSSCH (state, updcussch) {
    state.updcussch = updcussch;
    setSessionStorage('updcussch', updcussch)
  },
  SAVE_UPDCARDSCH (state, updcardsch) {
    state.updcardsch = updcardsch;
    setSessionStorage('updcardsch', updcardsch);
  },
  SAVE_SCHEDULE (state, schedule) {
    state.schedule = schedule;
    setSessionStorage('schedule', schedule);
  },
  CHANGE_LOGSTATE (state, isLogin) {
    state.isLogin = isLogin;
    setSessionStorage('isLogin', isLogin);
  },
  SAVE_USERID (state, userId) {
    state.userId = userId;
    setSessionStorage('userId', userId);
  },
  SAVE_CHKSTS (state, chksts) {
    state.chksts = chksts;
    setSessionStorage('chksts', chksts);
  },
  SAVE_USERNAME (state, userName) {
    state.userName = userName;
    setSessionStorage('userName', userName);
  },
  SAVE_ISEMAIL (state, isEmail) {
    state.isEmail = isEmail;
  },
  SAVE_EMAIL (state, email) {
    state.email = email;
  },
  SAVE_NEWEMAIL (state, newEmail) {
    state.newEmail = newEmail;
  },
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/users.js